<template>
  <div class="container">
    <el-empty description="页面跳转中..."></el-empty>
  </div>
</template>

<script>
export default {
  name: "redirectPage",
  data(){
    return {

    }
  },
  mounted() {
    let token=this.$route.query["token"];
    let pageUrl=this.$route.query["redirectUrl"];
    if (token){
      this.$cookie.set('access_token', token)
      this.$cookie.set('oauth_access_token', token)
        localStorage.setItem('access_token', token)
      if (!pageUrl){
        pageUrl='/';
      }
      window.location.href = ''+pageUrl
      return
    }
  }
}
</script>

<style scoped>

</style>
